<template>
  <div>
    <div class="data-list-header">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">活动总数</div>
            <div class="number">{{textForm.activityCount || 0}}</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">进行中活动</div>
            <div class="number">{{textForm.ongoingActivity || 0}}</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">待开始活动</div>
            <div class="number">{{textForm.waitingActivitiy || 0}}</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">已结束活动</div>
            <div class="number">{{textForm.finishedActivity || 0}}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form  :inline="true" :model="searchForm" ref="searchForm" label-width="70px" size="mini">
          <el-form-item label="活动id" prop="activityId" label-width="80px">
            <el-input class="form-input" type="number" v-model="searchForm.activityId" clearable></el-input>
          </el-form-item>
          <el-form-item label="活动名称" prop="activityName" label-width="80px">
            <el-input class="form-input" v-model="searchForm.activityName" clearable></el-input>
          </el-form-item>
          <el-form-item label="模板名称" prop="tmpName" label-width="80px">
            <el-input class="form-input" v-model="searchForm.tmpName" clearable></el-input>
          </el-form-item>
          <el-form-item label="创建人" prop="createdUserName" label-width="80px">
            <el-input class="form-input" v-model="searchForm.createdUserName" clearable></el-input>
          </el-form-item>
          <el-form-item label="创建时间" prop="addTime" label-width="80px">
            <q-date-picker startFiled="createTimeStart" endFiled="createTimeEnd" v-model="searchForm" ref="creatDateFef" />
          </el-form-item>
          <el-form-item label="截止时间" label-width="80px">
            <q-date-picker startFiled="endTimeStart" endFiled="endTimeEnd" v-model="searchForm" ref="dateRef" />
          </el-form-item>
          <el-form-item label="活动状态" prop="dataType" label-width="80px">
            <el-select v-model="searchForm.dataType" clearable @change="onSearch">
              <el-option v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <!-- <el-button type="primary" size="small" @click="handleAdd(null, 1)">新增</el-button> -->
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        border
        highlight-current-row
        :data="tableData"
        :height="maxTableHeight">
        <el-table-column prop="activityId" label="活动ID" width="80" align="center"></el-table-column>
        <el-table-column prop="activityName" label="活动名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="tmpName" label="模板名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdUserName" label="创建人"  show-overflow-tooltip width="100" align="center"></el-table-column>
        <el-table-column prop="createdUserRoleName" label="创建时的角色"  show-overflow-tooltip align="center" width="110"></el-table-column>
        <el-table-column prop="joinStaffNumber" label="参与职员" width="100" align="center"></el-table-column>
        <el-table-column prop="browsePeopleNumber" label="浏览人数" width="100" align="center"></el-table-column>
        <el-table-column prop="signUpNumber" label="参与人数" width="100" align="center"></el-table-column>
        <el-table-column label="报名费用(元)" width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.signUpfee || '免费' }}
          </template>
        </el-table-column>
        <el-table-column prop="salesAmount" label="活动金额" width="100" align="center"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="155"></el-table-column>
        <el-table-column prop="endTime" label="截止时间" width="155">
          <template slot-scope="scope">
            {{scope.row.endTime | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column prop="rollingStatus" label="状态" width="80" align="center">
          <template slot-scope="scope">
            {{scope.row.dataType | statusEnum}}
          </template>
        </el-table-column>
        <el-table-column  label="操作" width="240" class-name="action-column" align="center">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="btnPreview(scope.row)">预览</el-button>
            <el-button type="text" size="small" @click="handleAdd(scope.row, 3)">查看</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">关闭活动</el-button>
            <el-button type="text" size="small" @click="handlepartake(scope.row)">参与隐藏</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <el-dialog title="预览" :visible.sync="isPreview" width="30%" destroy-on-close>
      <div class="content">
        <span>{{timeNumber}}s后关闭,请尽快扫码预览</span>
        <img class="or-code" :src="qrCode" alt="" >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" @click="isPreview = false">关闭</el-button>
      </span>
    </el-dialog>
  </content-panel>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import { envVersion } from '@/utils/auth'
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "ActivityList",
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        activityId: '',
        activityName: '',
        tmpName: '',
        createdUserName: '',
        createTimeStart: "",
        createTimeEnd: "",
        endTimeStart: "",
        endTimeEnd: "",
        dataType: ''
      },
      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      // 0草稿1待开始2进行中3已结束
      statusOptions: [
        {value: '', label: '全部'},
        // {value: 0, label: '草稿箱'},
        {value: 1, label: '待开始'},
        {value: 2, label: '进行中'},
        {value: 3, label: '已结束'},
      ],
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
      isPreview: false,
      time: null,
      timer: null,
      timeNumber:10,
      qrCode: '',
      panelData: {},
      textForm: {}
    }
  },
  watch: {
    isPreview(newValue) {
      if (!newValue) {
        if (this.timer) {
          clearInterval(this.timer)
          this.timeNumber = 10
        }
      }
    },
  },
  methods: {
    init() {
      this.onSearch();
    },
    findActivityNum() {
      this.$api.ActivityManagement.findActivityNum()
      .then(res => {
        this.textForm = res.data
      })
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        }
      }
      this.$api.ActivityManagement.activityList(params)
        .then(({data: {list, total}}) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {
        createUserId: this.$route.query.userId || ''
      };
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== 'undefined' && val !== null && val !== '') {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.createTimeStart = "",
      this.searchForm.createTimeEnd = "",
      this.searchForm.endTimeStart = "",
      this.searchForm.endTimeEnd = "",
      this.$refs.dateRef.reset()
      this.$refs.creatDateFef.reset()
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;

      if (actionType == 3) {
        this.openSubPage({
          path: '/activity/detail',
          query: {activityId: row.activityId}
        })
      }
    },
    handleState(row, state) {
      this.$api.carouselImage
        .updateState(row.rollingId, state)
        .then(({data}) => {
          this.$notify.success({
            title: '成功',
            message: '操作成功',
          });
          this.getList();
        });
    },
    handleDelete(row) {
      this.$confirm('提示是否关闭活动', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.ActivityManagement
            .closeActivity(row.activityId)
            .then(({data}) => {
              this.$notify.success({
                title: '成功',
                message: '关闭成功',
              });
              this.getList();
            })
            .finally(() => {
              this.loading = false;
            });
          
        })
        .catch(() => {});
    },
    btnPreview(row) {
      this.loading = true
      let requestParames = {
        activityId: row.activityId,
        env_version:  envVersion
      }
      this.$api.ActivityManagement
        .activityPreview(requestParames).then(res => {
          if (res.success) {
            let str = `data:image/jpg;base64,${res.data}`
            this.qrCode = str.replace(/[\r\n]/g, '')
            this.isPreview = true
            this.countDown()
            if (this.time) clearTimeout(this.time)
            this.time = setTimeout(() => {
              this.isPreview = false
            }, 10000);
            this.loading = false
          }
        }).catch(err => {
          this.loading = false
        })
    },
    handlepartake(row) {
      if (row.createdUserRoleName == '活动老师' || row.createdUserRoleName =='活动老师升级角色(数钱权限)') {
        this.openSubPage({
          path: 'partake-list',
          query: {activityId:row.activityId}
        })
      } else {
        this.$message.error('只能对活动老师创建的活动进行操作')
      }
    },
    countDown() {
      this.timer = setInterval(()=> {
        if (this.timeNumber > 0) {
          this.timeNumber--
        }else {
          clearInterval(this.timer)
          this.timeNumber = 10
        }
      },1000)
    }
  },
  filters: {
    statusEnum(val) {
      const map = {
        0: '草稿',
        1: '待开始',
        2: '进行中',
        3: '已结束'
      };
      return map[val] || '';
    }
  },
  watch: {
    $route: {
      handler(val, olv) {
        let query = val.query;
        if (
          olv.path == "/dataReport/dealer" &&
          JSON.stringify(query) != "{}" &&
          (query.userId != this.filterParam.createUserId)
        ) {
          this.filterParam.createUserId = this.$route.query.userId || ''
          this.init();
        }
      },
    },
  },
  mounted() {
    this.findActivityNum()
    this.filterParam.createUserId = this.$route.query.userId || ''
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
.date-input {
  width 130px !important
}
.to {
  display: inline-block;
  margin: 0 4px;
}
.content 
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  flex-direction column
  .or-code 
    width 140px
    height 140px
    margin-top 20px

.data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      padding: 6px 0;
      border-bottom: 1px solid #ccc;
    }
    .number {
        text-align: center;
        padding: 6px 0;
    }
  }
</style>